import React from 'react';

interface SinglePayoutProps {
  activeStep: number
}

export const STEP_1 = 1;
export const STEP_2 = 2;

export const SinglePayoutContext = React.createContext<SinglePayoutProps>({
  activeStep: STEP_1
});